import {addStyleClass, removeStyleClass} from "../../common/colors";

/*
 [CheckRow]: Encapslates a row in a CheckTable.
 Properties
 id: the unique identifier of the row
 Methods
 getChecked(): determine if the row is checked
 setChecked(checked): set the checked state of the row.  This will update the checkbox and the rows CSS class
 */
export function CheckRow(
    id, // row identifier
    rowElement, // <tr> element for the row
    checkboxElement, // checkbox input element
    uncheckedClassName, // CSS class name for the row when it is unchecked
    checkedClassName
) {
    this.id = id;
    this.rowElement = rowElement;
    this.checkboxElement = checkboxElement;
    this.checkedClassName = checkedClassName;
    this.uncheckedClassName = uncheckedClassName;

    this.getIndex = function() {
        let i;
        let node = this.rowElement;
        for (i = 0; (node = node.previousElementSibling); i++);
        // add 1, because this index is only relative to the rows
        // in the tbody and we need to add 1 for the header row.
        return i + 1;
    };

    this.setChecked = function(checked) {
        this.checkboxElement.checked = checked;

        if (checked) {
            removeStyleClass(this.rowElement, this.uncheckedClassName);
            addStyleClass(this.rowElement, this.checkedClassName);
        } else {
            removeStyleClass(this.rowElement, this.checkedClassName);
            addStyleClass(this.rowElement, this.uncheckedClassName);
        }
    };

    this.getChecked = function() {
        return this.checkboxElement.checked;
    };
}